type RingType = {
  height: number;
  width: number;
};

const Ring = ({ height, width }: RingType) => (
  <div
    style={{
      backgroundColor: "#fff",
      border: "0.1px solid #000",
      opacity: 0.15,
      height,
      borderRadius: "50%",
      MozBorderRadius: "50%",
      WebkitBorderRadius: "50%",
      width,
    }}
  />
);

export default Ring;
